import { useParams } from "react-router-dom";
import { LEVEL } from "../consts";
import type {
  Level
} from "../types";

export function useRouteParamsLo() {
  const { id, learningObjectTypology, courseId, rootId } = useParams<{
    id: string;
    learningObjectTypology: Level;
    courseId?: string;
    rootId?: string;
  }>();

  const idNumber = id ? Number(id) : NaN;
  const courseIdNumber = courseId
    ? Number(courseId)
    : learningObjectTypology === LEVEL.COURSE
      ? idNumber
      : NaN;
  const rootIdNumber = rootId
    ? Number(rootId)
    : learningObjectTypology === LEVEL.PATH && idNumber
      ? idNumber
      : NaN;

  return {
    idString: id,
    learningObjectTypology,
    idNumber,
    courseIdNumber,
    rootIdNumber
  };
}
